<template>
  <!-- <h4>Primary sponsor</h4>
  <h4>Co-sponsors</h4> -->
  <div>
    <a href="https://www.biologists.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/CoB-lightMode.svg"
        alt="CoB"
        title="The Company of Biologists" />
      <img v-else src="./img/CoB.svg" alt="CoB" title="The Company of Biologists" />
    </a>
    <a href="https://www.frontiersin.org/journals/bioinformatics" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        id="frontiers"
        src="./img/frontiers-lightMode.svg"
        alt="FBINF"
        title="Frontiers in Bioinformatics" />
      <img
        v-else
        id="frontiers"
        src="./img/frontiers.svg"
        alt="FBINF"
        title="Frontiers in Bioinformatics" />
    </a>
    <a href="https://biovis.net/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        class="biovis"
        src="./img/biovis-lightMode.svg"
        alt="BioVis "
        title="BioVis" />
      <img v-else class="biovis" src="./img/biovis.svg" alt="BioVis " title="BioVis" />
    </a>
    <a href="https://www.thermofisher.com/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/thermo-lightMode.svg"
        alt="Thermo Fisher"
        title="Thermo Fisher" />
      <img v-else id="thermo" src="./img/thermo.svg" alt="Thermo Fisher" title="Thermo Fisher" />
    </a>
    <a href="https://vcc.kaust.edu.sa/" rel="nofollow">
      <img id="kaust" src="./img/kaust.png" alt="KAUST VCC" title="KAUST Visual Computing Center" />
    </a>
  </div>
  <h4>Affiliates</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpeg" alt="ISCB" title="ISCB" />
    </a>
    <a href="https://www.eg.org/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/EG-lightMode.png"
        alt="Eurographics"
        title="Eurographics" />
      <img v-else src="./img/EG.png" alt="Eurographics" title="Eurographics" />
    </a>
    <a href="https://www.datavisualizationsociety.org" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/DVS-lightMode.png"
        alt="Data Visualization Society"
        title="Data Visualization Society" />
      <img v-else src="./img/DVS.png" title="Data Visualization Society" />
    </a>
    <!-- <a href="https://www.magd.cam.ac.uk/" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Magdalene.jpg"
        alt="Magdalene"
        title="Magdalene" />
      <img v-else src="./img/Magdalene.svg" alt="Magdalene" title="Magdalene" />
    </a> -->
  </div>

  <h4>Become a Sponsor</h4>
  <p>
    Partner with us to shape the future of data visualization! By sponsoring VIZBI 2026, you'll gain
    exclusive access to a targeted audience of leading academics, scientific publishers,
    communicators, and representatives from the major life science industries. Showcase your brand,
    build meaningful connections, and highlight your dedication to driving progress and innovation.
    Let's collaborate to create meaningful impact and lasting relationships.
  </p>

  <h4 id="tech-track">Give a Tech-Track Talk <!-- <span>New!</span> --></h4>
  <p>
    VIZBI offers a small number of dedicated Tech Track presentation slots within the main
    program of its in-person meetings. These are intended primarily for companies
    developing commercial technologies that connect data visualization with any aspect of the life
    sciences, and that would be of clear interest to the VIZBI community. However, this format can
    also suit academically led tools or resources that meet the same criteria and are of broad
    value.
  </p>
  <p>
    Each Tech Track slot consists of a 20-minute presentation followed by 5 minutes of Q&amp;A,
    providing a focused opportunity to present tools, platforms, or recent developments to an
    audience of leading researchers, publishers, and practitioners working at the intersection of
    biology and data visualization.
  </p>
  <p>
    Tech Track talks are announced to the VIZBI mailing list of around 5,000 people, and VIZBI
    typically draws between 100 and 400 participants each year.
  </p>
  <p>
    The fee for a Tech Track slot is USD&nbsp;$1,000. This fee does not include conference
    registration. There are three Tech Track slots per meeting, subject to availability.
  </p>

  <h4>Ready to take the next step?</h4>
  <p>
    Reach out to us directly at <Email to="vizbi-contact" /> and let's explore customized
    sponsorship opportunities that align with your goals!
  </p>
  <!--
  <h4>Media Partners</h4>
  <div>
    <a href="http://www.digizyme.com/" rel="nofollow">
      <img src="./img/Digizyme.png" alt="Digizyme" />
    </a>
    </a>
    <a href="https://iubmb.org/">
      <img src="./img/iubmb.jpeg" alt="IUBMB" title="International Union of Biochemistry and Molecular Biology" />
    </a>
    <a href="https://peerj.com/">
      <img src="./img/PeerJ.png" alt="PeerJ" title="PeerJ" />
    </a>
    <a href="http://rsob.royalsocietypublishing.org/">
      <img src="./img/rsob.png" alt="Open Biology" title="Open Biology, a Royal Society journal" class="openBiology" />
    </a>
  </div>
    -->
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import Email from "@/components/Email.vue";
import {inject} from "vue";

const displayMode = inject("displayMode");
</script>

<style scoped>
/* Styles in this page are set in views/Sponsors.vue using the deep selector */
/* Some logos need individual adjustments */
/* https://stackoverflow.com/q/3029422 */

img.biovis {
  height: 2.3rem !important;
}
img#frontiers {
  height: 2.3rem !important;
}
.narrow img#frontiers {
  height: 1.7rem !important;
}
img#kaust {
  max-height: 5rem !important;
}
.narrow img#kaust {
  max-height: 3rem !important;
}
h4 span {
  color: red;
}
</style>
